export const UPDATE_TRANSACTION_IN_PROGRESS = 'UPDATE_TRANSACTION_IN_PR';
export const SET_TRANSACTION_FAILED = 'SET_TRANSACTION_FAILED';
export const SET_TRANSACTION_SUCCESS = 'SET_TRANSACTION_SUCCESS';

export default function TransactionsInProgressReducer (state = {}, action) {
  let newState = {};
  switch (action.type) {
    case UPDATE_TRANSACTION_IN_PROGRESS:
      newState = {...state};
      newState[action.payload.txHash] = state[action.payload.txHash] || {
        txHash: action.payload.txHash,
        action: action.payload.action,
        result: null,
        validationMessage: action.payload.validationMessage
      };

      return newState;
    case SET_TRANSACTION_FAILED:
      newState = {...state};
      newState[action.payload.txHash].result = false;
      return newState;
    case SET_TRANSACTION_SUCCESS:
      newState = {...state};
      newState[action.payload.txHash].result = true;
      return newState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/storage/TransactionsInProgressReducer.js